<template>
  <div class="illustration" :class="classNames">
    <div class="illustration--which-spans__labels" v-if="which === 'spans'">
      <span
        v-if="hasCantilever"
        class="
          illustration__label
          illustration--which-spans__label
          illustration--which-spans__label--cantilever
          illustration--which-spans__label--cantilever--1
        "
        >{{ $t("Con.") }} #1</span
      >
      <span
        class="
          illustration__label
          illustration--which-spans__label
          illustration--which-spans__label--main
          illustration--which-spans__label--main--first
        "
        >{{ $t("Vão") }} #1</span
      >
      <span
        class="
          illustration__label
          illustration--which-spans__label
          illustration--which-spans__label--main
          illustration--which-spans__label--main--last
        "
        >{{ $t("Vão") }} #{{ lastMainSpanIdx }}</span
      >
      <span
        v-if="hasCantilever"
        class="
          illustration__label
          illustration--which-spans__label
          illustration--which-spans__label--cantilever
          illustration--which-spans__label--cantilever--2
        "
        >{{ $t("Con.") }} #2</span
      >
    </div>

    <img class="illustration__img" :src="src" />
  </div>
</template>

<script>
import { preloadImg } from "@/utils";

export default {
  props: {
    which: {
      type: String,
      required: true,
    },
    totalSpans: {
      type: Number,
    },
    hasCantilever: {
      type: Boolean,
      default: false,
    },
    isSpanBySpan: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: "relative",
      validator: (val) => ["relative", "absolute"].includes(val),
    },
  },
  data() {
    return {
      imgsWithCantileverVariation: ["spans"],
      imgsWithSpanBySpanVariation: ["genericLoad", "windSuction"],
    };
  },
  computed: {
    src() {
      let fileName = `${this.which}`;

      if (this.imgsWithCantileverVariation.includes(this.which)) {
        fileName += `--${
          this.hasCantilever ? "hasCantilever" : "hasntCantilever"
        }`;
      } else if (this.imgsWithSpanBySpanVariation.includes(this.which)) {
        fileName += `--${
          this.isSpanBySpan ? "isSpanBySpan" : "isntSpanBySpan"
        }`;
      }

      return this.requireFromDir(fileName);
    },

    lastMainSpanIdx() {
      if (this.hasCantilever) {
        return this.totalSpans - 2;
      } else {
        return this.totalSpans;
      }
    },

    classNames() {
      return [
        "illustration--which-" + this.which,
        "illustration--position-" + this.position,
      ];
    },
  },

  watch: {
    which: {
      immediate: true,
      handler(which) {
        if (this.imgsWithCantileverVariation.includes(which)) {
          //we preload both for fast switching
          preloadImg([
            this.requireFromDir(`${which}--hasCantilever`),
            this.requireFromDir(`${which}--hasntCantilever`),
          ]);
        }

        if (this.imgsWithSpanBySpanVariation.includes(which)) {
          preloadImg([
            this.requireFromDir(`${which}--isSpanBySpan`),
            this.requireFromDir(`${which}--isntSpanBySpan`),
          ]);
        }
      },
    },
  },

  methods: {
    requireFromDir(fileName) {
      return require(`@/assets/img/calc_illustrations/${fileName}.png`);
    },
  },
};
</script>

<style lang="scss" :scoped>
.illustration {
  max-width: 330px;

  &--position {
    &-relative {
      position: relative;
    }

    &-absolute {
      bottom: 42px;
      position: absolute;
      // right: 0;

      @media only screen and (max-width: 1110px) {
        position: relative;
        bottom: 0;
      }
    }
  }

  &__img {
    width: 100%;
    vertical-align: bottom;
  }

  &__label {
    position: absolute;
    font-weight: 600;
    font-size: 11px;
    @include useFontFamilyTitle;
    color: #666666;
  }

  //variations
  &--which {
    &-spans {
      padding-top: 20px;

      &__labels {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 24px;
      }

      &__label {
        bottom: 100%;

        &--main {
          &--first {
            left: 72px;
          }

          &--last {
            right: 72px;
          }
        }

        &--cantilever {
          &--1 {
            left: -6px;
          }

          &--2 {
            right: 0;
          }
        }
      }
    }

    &-angle {
      width: 160px;
      position: absolute;
      right: 21px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
